module.exports = __webpack_public_path__ + "static/media/delete_small.8f5771d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/delete_small.svg
// module id = 173
// module chunks = 0